import { twMerge } from "tailwind-merge";

export type BoxProp = {
    className?: string
    children: React.ReactNode
}

const Box = (props: BoxProp) => {

    return (
        <div className={twMerge("border border-secondary-100 rounded-xl p-3", props.className)}>
            {props.children}
        </div>
    )
}

export default Box